import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseApi, BASE_URL } from '@edl-development/edl-common';
import { FileAttachment } from '../model/attachment/file-attachment.model';
import { Observable, map } from 'rxjs';
import { CommentState } from '../model/enum/comment-state.enum';

@Injectable()
export class FileApi extends BaseApi {


  constructor(
    @Inject(BASE_URL) private baseUri: string,
    private http: HttpClient
  ) {
    super();
  }

  getUserFiles(offset?: number, limit?: number, searchBy?: string, orderBy?: string, ascending?:boolean) {
    let params = new HttpParams()
      .append('offset', String(offset))
      .append('limit', String(limit))
      .append('orderBy', String(orderBy??""))
      .append('ascending', String(ascending??"false"));

    if (searchBy) {
        params = params.append('searchBy', this.convertParam(searchBy));
    }


    return this.http.get(
      this.baseUri +
        '/file/userFiles', { params }
    );
  }

  getUserUsage() {
    return this.http.get(this.baseUri + '/file/userUsage');
  }

  getFilesForObservation(observationType: number, observationId: string, commentState?: CommentState) {
    let params = new HttpParams();

    if (commentState) {
      params = params.append('commentState', String(commentState));
    }

    return this.http.get(
      this.baseUri +
        '/file/observation/' +
        observationType +
        '/' +
        observationId,
      { params }
    );
  }

  getFile(guid: string) {
    return this.http
      .get(this.baseUri + '/file/f/' + guid, {
        responseType: 'blob',
      })
      .pipe(map(this.mapFileResponse));
  }

  getFileBlob(guid: string): Observable<Blob> {
    return this.http.get(this.baseUri + '/file/f/' + guid, {
      responseType: 'blob',
    });
  }

  getFileResponse(guid: string) {
    return this.http.get(this.baseUri + '/file/f/' + guid, {
      responseType: 'blob',
    });
  }

  getExport(guid: string) {
    return this.http.get(this.baseUri + '/file/e/' + guid, {
      responseType: 'blob',
    });
  }

  uploadFile({
    fileList, type, typeId, commentId, commentLabel
  }: {
    fileList: FileList;
    type: number;
    typeId: string;
    commentId:string;
    commentLabel:string;
  }) {
    let file: File = fileList[0];
    let formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('Type', type.toString());
    formData.append('TypeId', typeId);
    formData.append('commentId', commentId);
    formData.append('commentLabel', commentLabel);
    return this.http.post(this.baseUri + '/File', formData);
  }

  uploadSignature({
    signature,
    type,
    typeId,
    subTypeId,
    portalId,
    fileId,
  }: {
    signature: Blob;
    type: number;
    typeId: string;
    subTypeId: number;
    portalId: number;
    fileId?: string;
  }) {
    let formData: FormData = new FormData();
    formData.append('file', signature, 'signature.png');
    formData.append('Type', type.toString());
    formData.append('TypeId', typeId);
    formData.append('SubTypeId', subTypeId.toString());
    formData.append('PortalId', portalId.toString());

    if (fileId) {
      formData.append('FileId', fileId);
    }

    return this.http.post(this.baseUri + '/File', formData);
  }

  deleteFile(file:FileAttachment) {
    return this.http.delete(this.baseUri + '/file/' + file.fileID, {});
  }
}
